import { Button, Form, Input, message, Modal, Select, Space } from "antd";
import { useCreateConsumerPortalEmailAddressMutation } from "features/consumerPortalProfile/consumerPortalprofileAPI";
import { useFetchBackendConstantsQuery } from "features/home/agencyPortal/homeAPI";
import styled from "styled-components";

const StyledEmailInput = styled(Input)`
  width: 250px;
  @media (max-width: 470px) {
    width: 100%;
  }
`;

const StyledEmailSelect = styled(Select)`
  width: 120px;
  @media (max-width: 470px) {
    width: 100%;
  }
`;

function AddEmailAddressModal({ onClose }) {
  const [createEmailAddress] = useCreateConsumerPortalEmailAddressMutation();
  const { data: constants } = useFetchBackendConstantsQuery();

  const [form] = Form.useForm();

  const handleSave = async () => {
    const values = await form.validateFields();
    const result = await createEmailAddress(values);
    if ("data" in result) {
      message.success("Email address added successfully.", 2);
      onClose();
    }
  };

  return (
    <Modal
      maskClosable={false}
      title="New Email Address"
      onCancel={onClose}
      open
      footer={
        <Button type="primary" htmlType="submit" onClick={handleSave}>
          Add
        </Button>
      }
    >
      <Form form={form} layout="vertical" name="add_email_address_form" onFinish={handleSave}>
        <Space.Compact>
          <Form.Item hasFeedback name="address">
            <StyledEmailInput maxLength={100} placeholder="Email Address" />
          </Form.Item>
          <Form.Item hasFeedback name="type">
            <StyledEmailSelect
              popupMatchSelectWidth={false}
              allowClear
              style={{ width: 120 }}
              placeholder="Type"
              options={constants?.emailTypes.map(({ display, value }) => ({
                value,
                label: display,
              }))}
            />
          </Form.Item>
        </Space.Compact>
      </Form>
    </Modal>
  );
}

export default AddEmailAddressModal;
